export type LegalSubject =
    | 'Физическое лицо'
    | 'Индивидуальный предприниматель'
    | 'Юридическое лицо';

export const orgTypeNames = {
    FL: 'Физическое лицо',
    IP: 'Индивидуальный предприниматель',
    UL: 'Юридическое лицо',
};

export type OrgTypeFlags = {
    isFL: boolean;
    isIP: boolean;
    isUL: boolean;
};

export const getOrgTypeFlags = (orgTypeName?: LegalSubject): OrgTypeFlags => {
    return {
        isFL: orgTypeName === orgTypeNames.FL,
        isIP: orgTypeName === orgTypeNames.IP,
        isUL: orgTypeName === orgTypeNames.UL,
    };
};
